/* NC Teppich nach Maß – Seiten-Effekte: Einblenden, Aufbau-Animation, Inspirations-Filter, Links in den Konfigurator */
(function () {
  'use strict';
  if (window.__ncTnmPage) return;
  window.__ncTnmPage = true;

  function init() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Einblenden
    var items = document.querySelectorAll('.tnm-reveal:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      items.forEach(function (el) { io.observe(el); });
    }

    // Aufbau: Schichten fahren auseinander, sobald sichtbar
    document.querySelectorAll('[data-tnm-layers]:not([data-ready])').forEach(function (el) {
      el.setAttribute('data-ready', '');
      if (reduce || !('IntersectionObserver' in window)) { el.classList.add('is-open'); return; }
      new IntersectionObserver(function (en) {
        el.classList.toggle('is-open', en[0].intersectionRatio > 0.35);
      }, { threshold: [0, 0.35, 0.7] }).observe(el);
    });

    // Inspiration: nach Raum filtern
    document.querySelectorAll('[data-tnm-insp]:not([data-ready])').forEach(function (sec) {
      sec.setAttribute('data-ready', '');
      sec.addEventListener('click', function (e) {
        var b = e.target.closest('[data-tnm-room-filter]');
        if (!b) return;
        var f = b.getAttribute('data-tnm-room-filter');
        sec.querySelectorAll('[data-tnm-room-filter]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
        sec.querySelectorAll('.tnm-insp__item').forEach(function (it) {
          it.hidden = !(f === '*' || it.getAttribute('data-room') === f);
          if (!it.hidden) it.classList.add('is-in');
        });
      });
    });
  }

  // Links mit ?typ=…#teppich-konfigurator übernehmen die Werte ohne Neuladen
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-tnm-apply], a[href*="#teppich-konfigurator"]');
    if (!a) return;
    var root = document.querySelector('[data-tnm-root]');
    if (!root) return;
    var url = new URL(a.getAttribute('href'), window.location.href);
    if (url.pathname !== window.location.pathname) return;
    e.preventDefault();
    if (root._tnm && url.search) root._tnm.apply(url.searchParams);
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (url.search && window.history.replaceState) {
      var cur = new URL(window.location.href);
      url.searchParams.forEach(function (v, k) { cur.searchParams.set(k, v); });
      cur.hash = 'teppich-konfigurator';
      window.history.replaceState(null, '', cur.toString());
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
